<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Reporte Producción</h2>
                </div>
                <div class="col-lg-2">
                    
                </div>
            </div>

            <div class="row">
                <!-- <div class="col-lg-3">
                    <span class="bod">Filtrar por grupo:</span><br>

                    <div class="ng-autocomplete">
                        <ng-autocomplete 
                          [data]="grupos"
                          [searchKeyword]="keyword"
                          (selected)='selectEvent($event)'
                          (inputChanged)='onChangeSearch($event)'
                          (inputFocused)='onFocused($event)'
                          [itemTemplate]="itemTemplate"
                          [notFoundTemplate]="notFoundTemplate">                                 
                        </ng-autocomplete>
                        
                        <ng-template #itemTemplate let-item>
                        <a [innerHTML]="item.nombre"></a>
                        </ng-template>
                        
                        <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound">No hay resultados</div>
                        </ng-template>
                    </div>
                </div> -->

                <div class="col-lg-3">
                    Selecciona Grupo:
                    <select class="form-control"  #grupoSelect (change)="getClientesProduccionFiltro(grupoSelect.value, estatusSelect.value);">
                        <option value="">Seleccione Grupo</option>
                        <option *ngFor = "let grupo of grupos" [value]="grupo.id">{{grupo.nombre}}</option>
                    </select>
                    <br>
                </div>

                <div class="col-lg-3">
                    Estatus:
                    <select class="form-control"  #estatusSelect (change)="getClientesProduccionFiltro(grupoSelect.value, estatusSelect.value);">
                        <option value="2">En producción</option>
                        <option value="1">Todos</option>
                    </select>
                    <br>
                </div>

                
                <div class="col-lg-3">
                    <br>
                    <button class="btn btn-success" (click)="descargarExcel(grupoSelect.value, estatusSelect.value)">Exportar a Excel</button>

                </div>

            </div>

            <div class="row">
                <div class="col-lg-10">
                    <div class="row">
                        <div class="col-lg-4">
                            Clientes en el grupo: {{clientesGrupo}}<br>
                        </div>
                        <div class="col-lg-4">
                            Clientes en el producción: {{clientesEstatusDos}}<br>
                        </div>
                        <div class="col-lg-4">
                            Porcentaje: {{clientesEstatusDos/clientesGrupo*100 |  number : '1.2-2'}}%
                        </div>
                    </div>
                   
                    <br>
                    
                    
                    <table  class="table table-striped row-border hover">
                        <thead class="thead-dark">
                            <tr>
                                <td>ID</td>
                                <td>Nombre</td>
                                <td>Carrera</td>
                                <td>Grupo</td>
                                <td>Avance de pagos</td>
                                <td>Pagado</td>
                                <td>Total sin descuento</td>
                                <td>Descuentos</td>
                                <td>Total Final</td>
                                <td>Paquetes</td>
                                <td>Marcos</td>
                                <td>Fondo Marcos</td>
                                <td>Placa</td>
                                <td>Productos Adicionales</td>
                                <td>Color</td>
                                <td>Anillos</td>
                                <td>Dirigido a</td>
                                <td>Dedicatorias</td>
                                <td>Anotaciones</td>
                                <td>Editar</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let cliente of clientes">
                                <td>{{cliente.id}}</td>
                                <td>{{cliente.nombre}}</td>
                                <td>{{cliente.carrera}}</td>
                                <td>{{cliente.grupo}}</td>
                                <td>{{cliente.avance}}%</td>
                                <td>{{cliente.pagado | currency }}</td>
                                <td>{{cliente.monto_sin_descuento | currency}}</td>
                                <td>
                                    <div *ngFor="let descuento of cliente.descuentos">
                                        {{descuento.codigo}} - {{descuento.monto_descuento | currency}}<br>
                                    </div>
                                </td>
                                <td>{{cliente.total | currency}}</td>
                                <td>
                                    <div *ngFor="let paquete of cliente.paquetes">
                                        {{paquete.paquete}}<br>
                                    </div>
                                </td>
                                <td>
                                    <div *ngFor="let moldura of cliente.molduras">
                                        {{moldura.nombre}}<br>
                                    </div>
                                </td>
                                <td>
                                    <div *ngFor="let fondoMoldura of cliente.fondosMolduras">
                                        {{fondoMoldura.nombre}}<br>
                                    </div>
                                </td>

                                <td>
                                    <div *ngFor="let placa of cliente.placas">
                                        {{placa.nombre}}<br>
                                    </div>
                                </td>
                                
                                <td>
                                    <div *ngFor="let producto of cliente.productos">
                                        {{producto.producto}}<br>
                                    </div>
                                </td>

                                <td>
                                    <div *ngFor="let color of cliente.colores">
                                        {{color.nombre}}<br>
                                    </div>
                                </td>

                                <td>
                                    <div *ngFor="let anilloSelected of cliente.anillos">
                                        {{anilloSelected.nombre}} | {{anilloSelected.metal}} <br>Medida: {{anilloSelected.medida}} <br>{{anilloSelected.gramaje}} gramos
                                    </div>
                                </td>
                                <td>
                                    <div *ngFor="let dedicatoria of cliente.dedicatorias">
                                        {{dedicatoria.dirigido}}<br>
                                    </div>
                                </td>

                                <td>
                                    <div *ngFor="let dedicatoria of cliente.dedicatorias">
                                        {{dedicatoria.nombre}}<br>
                                    </div>
                                </td>

                                <td>
                                    <div *ngFor="let anotacion of cliente.anotaciones">
                                        {{anotacion.texto}}<br>
                                    </div>
                                </td>
                              
                                <td>
                                    <button class="btn btn-success fondoAmarillo" (click)="updateEstatus(3, cliente.id)">Marcar como finalizado</button>
                                </td>
                            </tr>
                        
                        </tbody>
                    </table>
                </div>
                
            </div>

            
        </div>
    </div>
</div>